import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { eventRecap } from './activityCheckout';

const EventCheckoutRecap = ({ event }) => {
  const { when, where, audience, description } = eventRecap(event);
  if (!when && !where && !audience && !description) return null;

  return (
    <Box
      width="100%"
      bg="white"
      borderRadius="lg"
      borderWidth="1px"
      borderColor="gray.200"
      px={4}
      py={3}
    >
      {when ? (
        <Text fontSize="sm" fontWeight="semibold" color="gray.800">
          {when}
        </Text>
      ) : null}
      {where ? (
        <Text fontSize="sm" color="gray.700" mt={when ? 1 : 0}>
          {where}
        </Text>
      ) : null}
      {audience ? (
        <Text fontSize="sm" color="gray.600" mt={1}>
          {audience}
        </Text>
      ) : null}
      {description ? (
        <Text fontSize="sm" color="gray.600" mt={2} noOfLines={3}>
          {description}
        </Text>
      ) : null}
    </Box>
  );
};

export default EventCheckoutRecap;
